import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import Loadable from '@loadable/component';

import './industries-impacted.styles.scss';

const Jump = Loadable(() => import('react-reveal/Jump'));

const industries = [
  {
    name: 'Food Processing',
    icon: <i className="flaticon-factory"></i>,
  },
  {
    name: 'Manufacturing',
    icon: <i className="flaticon-structure"></i>,
  },
  {
    name: 'Education',
    icon: <i className="flaticon-teacher"></i>,
  },
  {
    name: 'Healthcare',
    icon: <i className="flaticon-hospital"></i>,
  },
  {
    name: 'Third-Party Logistics',
    icon: <i className="flaticon-order"></i>,
  },
  {
    name: 'Restaurant Services',
    icon: <i className="flaticon-price-tag"></i>,
  },
  {
    name: 'Hospitality & Tourism',
    icon: <i className="flaticon-family-insurance"></i>,
  },
  {
    name: 'Luxury Gift Baskets',
    icon: <i className="flaticon-shopping-basket"></i>,
  },
];

const IndustriesImpacted: React.FC = () => {
  return (
    <div className="industries-impacted pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          <h2>Industries We Serve</h2>
        </div>

        <div className="row">
          {industries.map(({ name, icon }, i) => (
            <div className="col-lg-3 col-sm-6 col-md-6" key={i}>
              <Jump>
                <div className="single-industries-impacted-box">
                  <div className="icon">{icon}</div>
                  {name}
                  <AniLink
                    paintDrip
                    hex="#ff5d22"
                    to="/who-we-are"
                    className="link-btn"
                  ></AniLink>
                </div>
              </Jump>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IndustriesImpacted;
